import { t } from "@common/helpers/translator";
import { toast } from "react-toastify";
import { swarmRequest } from "@common/helpers/util/requestMiddleware";
import { UserDidLogOut } from "./terminal";
import { LOGGED_IN, LOGGED_OUT, LOGIN_FAILED } from "./actionTypes";
import { getPopupDispatchers } from "../contexts/popup";
import Config from "@skin_config";
import IdleService from "@common/services/idle";
import { clearRestoreLoginCreds, makeLogin } from "../helpers/login";
import { getOriginalCpf } from '../helpers/formatCpfNumber';

export const LoggedIn = (message) => ({
  type: LOGGED_IN,
  payload: message,
});

export const LoggedOut = (message) => ({
  type: LOGGED_OUT,
  payload: message,
});

export const LoginFailed = (message) => ({
  type: LOGIN_FAILED,
  payload: message,
});

export function Login(username, password, onSuccessLogin) {
  const { closePopup } = getPopupDispatchers();
  let formatedUsername = username;
  if (Config.main.cpfType === 'cpfs') {
    formatedUsername = getOriginalCpf(username);
  }
  return function (dispatch) {
    return swarmRequest({ username: formatedUsername, password }, 'login').then((response) => {
      if (response.status) {
        dispatch(LoginFailed(response));
      } else {
        Config.rfid.logoutIfIdleSecondsCount
          && IdleService.ifInactive(Config.rfid.logoutIfIdleSecondsCount, () => {
            dispatch(LoggedOut());
          });
        makeLogin({ authData: response });
        onSuccessLogin?.();
        closePopup();
      }
    });
  };
}

export function Logout(isIdle) {
  return async function (dispatch) {
    isIdle && toast.error(t('You have been logged out due to inactivity'));
    try {
      await swarmRequest({}, 'logout');
      dispatch(UserDidLogOut());
      dispatch(LoggedOut());
      // Drop the persisted restore-login pair so the next bootstrap
      // doesn't silently sign the user back in.
      clearRestoreLoginCreds();
    } catch { }
  };
}
